import { config } from "@repo/config";
import { AccountProfileSection } from "@saas/settings/components/AccountProfileSection";
import { SettingsPageIntro } from "@saas/settings/components/SettingsLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account/settings/general")({
	head: () => ({ meta: [{ title: `Your profile - ${config.appName}` }] }),
	component: ProfileSettingsPage,
});

function ProfileSettingsPage() {
	return (
		<>
			<SettingsPageIntro
				title="Profile"
				info="Your own details, the same in every retailer you belong to."
			/>
			<AccountProfileSection />
		</>
	);
}
